const formatPhone = (val) => {
    if (typeof val === 'string') {
        return val.replace(/(?:\+\d{2})?(\d{2})(\d{4,5})(\d{4})/g, '($1) $2-$3')
    }
    return val
}

export default formatPhone